<template>
  <nav
    class="navbar navbar-mobile"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <button
      @click="handleFocus"
      @focusout="handleFocusOut"
      tabindex="0">
        <heim-icon class="icon burger" icon="menu"></heim-icon>
      </button>
      <router-link
        title="Heimdall"
        class="navbar-item logo-large"
        to="/"
      ><heim-icon icon="logo"></heim-icon><span class="logo-text">Heimdall</span></router-link>
      <!-- i cheat for align menu burger in left and logo in center with flexbox -->
      <span></span>
    </div>
  </nav>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon";
export default {
  name: "heim-mobile",
  components: {
    HeimIcon
  },
  props: {
    query: {
      type: String
    }
  },
  data() {
    return {
      queryTerm: ""
    };
  },
  methods: {
    search() {
      this.$store.dispatch("search", this.queryTerm);
    },
    handleFocus() {
      document.querySelector("aside").classList.add("isOpen");
    },
    handleFocusOut(e) {
      const button = document.querySelector(".toggle-nav");
      e.relatedTarget != button
        ? document.querySelector("aside").classList.remove("isOpen")
        : "";
    }
  }
};
</script>

<style scoped>
.navbar,
.navbar-menu,
.navbar-start,
.navbar-end,
.navbar-mobile {
  display: flex;
  align-items: center;
}
.navbar-brand button {
  border: none;
  background: no-repeat;
}

.navbar-start {
  width: 100%;
}
.navbar-mobile {
  background-color: #ffffff;
  min-height: 3.25rem;
  position: relative;
  z-index: 30;
  border-bottom: 2px solid #f5f5f5;
  margin-bottom: 5px;
}
.navbar-menu {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.navbar-start {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  margin-right: auto;
}
.navbar-end {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin-left: auto;
}
.item {
  padding-left: 1rem;
  flex: 1 1 auto;
  align-self: auto;
}

.navbar-mobile {
  display: none;
}

#app .isOpen {
  transform: translateX(-100vw);
}

.navbar-brand {
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: space-between;
}

.navbar-brand .burger {
  color: var(--heim-secondary-color);
}

.logo-text {
  color: var(--heim-text-color);
  font-weight: bold;
}

@media screen and (max-width: 460px) {
  .navbar-mobile {
    display: block;
    position: sticky;
    top: 0px;
    z-index: 999;
  }
}
</style>

<style>
#app .isOpen {
  transform: translateX(0);
}
</style>
